export const getProductionHost = () => {
	return "wordfinder.yourdictionary.com";
};
